/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */

import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import ContactForm from './contactForm'
import useWindowSize from '../hooks/useWindowSize'
import CrossTopIcon from '../images/cross_top.svg'
import ArrowGreenIcon from '../images/arrow-green.svg'

const styles = {
  btn: {
    background: '#fd5021',
    border: 'none'
  },
  modalBody: { padding: '0 10px', color: '#d31d2c', textAlign: 'center' },
  contactFormHeading: {
    lineHeight: '23px',
    fontSize: '23px',
    margin: '0 10px'
  },
  contactForm: {
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  modalHeader: {
    color: '#fff',
    minHeight: '40px',
    borderBottom: 'none',
    position: 'relative',
    width: '100%'
  }
}

const ErrorModalPassenger = ({ show, onHide, errorMsg }) => {
  const { windowHeight } = useWindowSize()
  const [showCallUsOption, setShowCallUsOption] = useState(false)
  const isContactForm = errorMsg.passnegerCount

  const handleModalHide = () => {
    setShowCallUsOption(false)
    onHide(false)
  }

  return (
    <Modal show={show} onHide={handleModalHide} size='md' centered>
      <Modal.Header
        style={{
          background: isContactForm
            ? 'linear-gradient(180deg, #569aff, #0f4ead)'
            : '#f3f3f3',
          ...styles.modalHeader
        }}
      >
        {isContactForm && !showCallUsOption && (
          <Modal.Title>
            <div className='col-md-12'>
              <div className='call_us_banner' style={styles.contactFormHeading}>
                Redeem your group (9+) discount now!
                <br />
                Submit a request.
              </div>
            </div>
          </Modal.Title>
        )}
        <span
          onClick={handleModalHide}
          className='call_form_close_btn'
          style={{
            right: isContactForm ? '6px' : ''
          }}
        >
          <img src={CrossTopIcon} height={isContactForm ? '' : '20px'} alt='' />
        </span>
      </Modal.Header>
      <Modal.Body
        style={
          isContactForm
            ? {
                ...styles.contactForm,
                maxHeight: `${windowHeight - 95}px`,
                background: 'linear-gradient(180deg, #569aff, #0f4ead)'
              }
            : styles.modalBody
        }
      >
        {isContactForm ? (
          <ContactForm
            setShowCallUsOption={setShowCallUsOption}
            mountedInErrorPopup
          />
        ) : (
          <div className='m_modal'>
            <ul>
              {Object.values(errorMsg).map(
                err =>
                  err &&
                  err.split('**').map(errItem => (
                    <li key={errItem}>
                      <img src={ArrowGreenIcon} alt='' />
                      <span dangerouslySetInnerHTML={{ __html: errItem }} />
                    </li>
                  ))
              )}
            </ul>
          </div>
        )}
      </Modal.Body>
      {!isContactForm && (
        <Modal.Footer
          style={{
            float: 'left',
            width: '100%',
            padding: '10px 15px'
          }}
        >
          <Button style={styles.btn} onClick={handleModalHide}>
            Okay
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  )
}
export default ErrorModalPassenger
